import { useId } from 'react'
import { Plus } from 'lucide-react'
import styles from './DashboardSection.module.css'

// One area of the dashboard (Key Metrics, Analysis & Insights) with its own
// grid. A section with nothing in it is left out of the dashboard. While
// editing, a slim bar under the grid says the section can hold more and opens
// the library on it; an empty section is just that bar. `actions` sit on the
// title's line, at its end (a fixed page's own controls for the section).
export function DashboardSection({ title, subtitle, actions = null, empty = false, editing = false, onAdd, children }) {
  const titleId = useId()
  if (empty && !editing) return null
  return (
    <section className={styles.section} aria-labelledby={titleId}>
      <header className={styles.header} data-actions={actions ? '' : undefined}>
        <div className={styles.heading}>
          <h2 id={titleId} className={styles.title}>{title}</h2>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </header>
      {empty ? null : children}
      {editing && onAdd ? (
        <button type="button" className={styles.addBar} onClick={onAdd} aria-label={`Add widget to ${title}`}>
          <Plus size={16} aria-hidden="true" />
          Add widget
        </button>
      ) : null}
    </section>
  )
}
